import { createFileRoute } from "@tanstack/react-router";

import { EmployeeFormPage } from "@/components/employees/form";
import { RequirePermission } from "@/hooks/shared/CheckAuth";

export const Route = createFileRoute("/_main/dashboard/employees/new")({
  component: () => (
    <RequirePermission action="employees.create">
      <EmployeeFormPage />
    </RequirePermission>
  ),
});
